import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Icons, Typography } from '@nutrien/cxp-components';
import React, { useState } from 'react';

import { useOnlineStatus } from '../../utilities';

const useStyles = makeStyles({
  confirmLogoutTextGrid: {
    marginBottom: '16px',
  },
});

interface Props {
  open: boolean;
  onCancel: () => void;
  onLogout: () => void;
  disableEnforceFocus?: boolean;
}

const LogoutModal: React.FC<Props> = ({ open, onCancel, onLogout, disableEnforceFocus }: Props) => {
  const classes = useStyles();
  const isOnline = useOnlineStatus();
  const [logoutClicked, setLogOutClicked] = useState<boolean>(false);

  const handleClose = () => {
    onCancel();
  };

  const handleLogoutClick = () => {
    setLogOutClicked(true);
    onLogout();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      titleText="Log out"
      backButton={false}
      disableEnforceFocus={disableEnforceFocus}
      disableEscapeKeyDown
      dialogActions={
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={5}>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="primary"
              noMinHeight
              data-testid="logoutcancelbutton"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button
              onClick={handleLogoutClick}
              disabled={!isOnline || logoutClicked}
              isLoading={logoutClicked}
              variant="contained"
              color="primary"
              noMinHeight
              data-testid="logoutButton"
            >
              Log out
            </Button>
          </Grid>
        </Grid>
      }
      maxWidth="xs"
      noMinHeight
    >
      <Grid container>
        <Grid item xs={1}>
          <Icons.InfoFeather color="error" />
        </Grid>
        <Grid item xs={11} className={classes.confirmLogoutTextGrid}>
          <Typography variant="body1">Are you sure you want to log out?</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default LogoutModal;
